import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { defaultComponentStyle } from "../../../components/Forms/elementsDefaultStyling";
const initialState = [
  {
    id: uuidv4(),
    instanceId: uuidv4(),
    elements: [],
    title: "Section 1",
  
    style: {}, // Add default style if needed
  },
];

const customFormBuilder = createSlice({
  name: "customFormBuilder",
  initialState,
  reducers: {
    addSection: (state, action) => {
      action.style = defaultComponentStyle.section;
      state.push(action.payload);
      console.log("addSection", state);
      // No return needed with Immer
    },
    // Replace the existing openNewForm reducer with this:
    openNewForm: (state, action) => {
      console.log("openNewForm", action.payload);

      // Clear the existing state array
      state.length = 0;

      // Ensure payload.metadata exists and is an array
      if (action.payload.metadata && Array.isArray(action.payload.metadata)) {
        // Add all elements from metadata to the state
        action.payload.metadata.forEach((item) => {
          state.push(item);
        });
      }
      // If it's not an array but a single object
      else if (action.payload.metadata) {
        state.push(action.payload.metadata);
      }
      // Fallback - add an empty section if no valid metadata
      else {
        state.push({
          id: uuidv4(),
          instanceId: uuidv4(),
          elements: [],
          title: "Section 1",
          style: {},
        });
      }
    },
    loadExistingForm: (state, action) => {
      console.log("loadExistingForm", action.payload);

      // Clear the existing state array
      state.length = 0;

      // Load the metadata (form structure)
      if (action.payload.metadata && Array.isArray(action.payload.metadata)) {
        action.payload.metadata.forEach((item) => {
          state.push(item);
        });
      } else if (action.payload.metadata) {
        // If it's a string, parse it
        try {
          const parsedMetadata =
            typeof action.payload.metadata === "string"
              ? JSON.parse(action.payload.metadata)
              : action.payload.metadata;

          if (Array.isArray(parsedMetadata)) {
            parsedMetadata.forEach((item) => {
              state.push(item);
            });
          } else {
            state.push(parsedMetadata);
          }
        } catch (error) {
          console.error("Error parsing metadata:", error);
          // Fallback to empty section
          state.push({
            id: uuidv4(),
            instanceId: uuidv4(),
            elements: [],
            title: "Section 1",
            style: {},
          });
        }
      } else {
        // Fallback - add an empty section if no valid metadata
        state.push({
          id: uuidv4(),
          instanceId: uuidv4(),
          elements: [],
          title: "Section 1",
          style: {},
        });
      }
    },

    removeSection: (state, action) => {
      // Validate the index before removal
      const { index } = action.payload;

      if (index >= 0 && index < state.length) {
        state.splice(index, 1);
        console.log("removeSection", state);
      } else {
        console.error("Invalid section index for removal:", index);
      }
    },

    updateStyling: (state, action) => {
      // First, check if it's a section
      const sectionIndex = state.findIndex(
        (section) => section.instanceId === action.payload.id
      );

      if (sectionIndex !== -1) {
        // It's a section - merge the styles instead of replacing
        state[sectionIndex].style = {
          ...state[sectionIndex].style,
          ...action.payload.data,
        };
      } else {
        // It's an element - iterate through each section
        for (let i = 0; i < state.length; i++) {
          const section = state[i];
          if (section.elements) {
            for (let j = 0; j < section.elements.length; j++) {
              const element = section.elements[j];
              if (element.instanceId === action.payload.id) {
                // Merge the styles instead of replacing
                element.style = {
                  ...element.style,
                  ...action.payload.data,
                };
                return; // Exit once found and updated
              }
            }
          }
        }
      }
    },
    // Fix for the moveElements reducer in customFormBuildeSclice.js

    moveElements: (state, action) => {
      const { formSection, toSection, fromIndex, toIndex } = action.payload;

      // Prevent invalid operations or no-op moves
      if (
        formSection < 0 ||
        formSection >= state.length ||
        toSection < 0 ||
        toSection >= state.length ||
        fromIndex < 0 ||
        (state[formSection].elements &&
          fromIndex >= state[formSection].elements.length) ||
        toIndex < 0 ||
        (formSection === toSection && fromIndex === toIndex)
      ) {
        console.error("Invalid indices for moveElements operation");
        return;
      }

      // Check if source section has elements array
      if (
        !state[formSection].elements ||
        !Array.isArray(state[formSection].elements)
      ) {
        console.error(
          `Source section at index ${formSection} doesn't have valid elements array`
        );
        return;
      }

      // Ensure destination section has elements array
      if (!state[toSection].elements) {
        state[toSection].elements = [];
      }

      // Create a copy of the element to move
      const movedElement = JSON.parse(
        JSON.stringify(state[formSection].elements[fromIndex])
      );

      // Handle moving elements within the same section
      if (formSection === toSection) {
        // Get the section's elements (reference is OK, we're not replacing the array)
        const elements = state[toSection].elements;

        // Remove the element from its original position
        elements.splice(fromIndex, 1);

        // Calculate valid toIndex (may have changed after removal)
        const validToIndex = Math.min(toIndex, elements.length);

        // Insert it at the new position
        elements.splice(validToIndex, 0, movedElement);
      }
      // Handle moving elements between different sections
      else {
        // Remove from source section
        state[formSection].elements.splice(fromIndex, 1);

        // Add to destination section at the specified position
        const validToIndex = Math.min(
          toIndex,
          state[toSection].elements.length
        );
        state[toSection].elements.splice(validToIndex, 0, movedElement);
      }
    },
    moveSections: (state, action) => {
      const { sourceIndex, targetIndex } = action.payload;

      // Validate indices
      if (
        sourceIndex === targetIndex ||
        sourceIndex < 0 ||
        sourceIndex >= state.length ||
        targetIndex < 0 ||
        targetIndex > state.length
      ) {
        return; // Early return, no modification needed
      }

      // Get the section to move
      const sectionToMove = state[sourceIndex];

      // Remove from original position and insert at new position
      state.splice(sourceIndex, 1);
      state.splice(targetIndex, 0, sectionToMove);

      console.log("moveSections", state);
      // No return needed with Immer
    },

    addComponent: (state, action) => {
      if (!state[action.payload.index].elements) {
        state[action.payload.index].elements = [];
      }
      if (defaultComponentStyle[action.payload.data.id]) {
        var style = JSON.parse(
          JSON.stringify(defaultComponentStyle[action.payload.data.id])
        );
        action.payload.data.style = style;
      }

      console.log("addComponent", action.payload);
      state[action.payload.index].elements.push(action.payload.data);

      // No return needed with Immer
    },

    removeComponent: (state, action) => {
      state[action.payload.index]["elements"].splice(
        action.payload.fieldIndex,
        1
      );
      console.log("removeComponent", state);
      // No return needed with Immer
    },

    updateSectionTitle: (state, action) => {
      const { index, title } = action.payload;

      if (index >= 0 && index < state.length) {
        state[index].title = title;
      }

      console.log("updateSectionTitle", state);
      // No return needed with Immer
    },

    getElementById: (state, action) => {
      return state.map((section) => {
        if (section.elements) {
          return section.elements.find(
            (element) => element.instanceId === action.payload.id
          );
        }
      });
    },
  },
});

export const {
  addSection,
  updateStyling,
  addComponent,
  removeComponent,
  moveElements,
  removeSection,
  moveSections,
  updateSectionTitle,
  getElementById,
  loadExistingForm,
  openNewForm,
} = customFormBuilder.actions;

export default customFormBuilder.reducer;
